import {Api} from "../api/api";
import {renderElements} from "../utils/common";

type TimerType = {
  userName: string,
  taskName: string,
  taskUrl: string,
  projectName: string,
  avatar: string,
  hours: string,
  minutes: string,
  seconds: string
}

const getTimerItemTemplate = ({
  userName,
  taskName,
  taskUrl,
  projectName,
  avatar,
  hours,
  minutes,
  seconds,
}: TimerType) => {
  return `<li class="task__item">
    <a href="${taskUrl}" class="task__link task__link--timer">
      <div class="task__left">
        <div class="responsible">
          <div class="responsible__img responsible__img--timer">
            <img src="${avatar}" class="responsible__icon" alt="Аватар пользователя ${userName}" width="21" height="21" title="${userName}">
          </div>
        </div>
        <p class="task__name task__name--timer">
          ${taskName}
        </p>
      </div>
      <div class="task__right">
        <p class="task__project task__project--timer">
          ${projectName}
        </p>
        <span class="timer-modal__time">
          <span class="js-timer-hours">${hours}</span>:<span class="js-timer-minutes">${minutes}</span><span class="timer__seconds">:<span
              class="js-timer-seconds">${seconds}</span>
          </span>
        </span>
      </div>
    </a>
  </li>`;
};

export class AdminTimers {
  private adminTimerButtonElement: HTMLElement | null = document.querySelector(".js-admin-timers-btn");
  private adminTimerModalElement: HTMLElement | null = document.querySelector(".js-admin-timer-modal");
  private adminTimerListElement: HTMLElement;
  private document = document;
  private api = new Api();
  private timersIntervals: number[] = [];
  private isOpenList = false;

  constructor() {
    this.onTimerButtonClick = this.onTimerButtonClick.bind(this);
    this.onDocumentButtonClick = this.onDocumentButtonClick.bind(this);
    this.startTimer = this.startTimer.bind(this);
  }

  init() {
    if (this.adminTimerButtonElement && this.adminTimerModalElement) {
      this.adminTimerListElement = this.adminTimerModalElement.querySelector(`.js-admin-timers-list`)!;

      this.adminTimerButtonElement.addEventListener(`click`, this.onTimerButtonClick);
    }
  }

  private toggleOpenStatus() {
    this.isOpenList = !this.isOpenList;
  }

  private openTimerList() {
    this.adminTimerModalElement?.classList.add("timer-modal--show");

    this.document.addEventListener(`click`, this.onDocumentButtonClick);
  }

  private closeTimerList() {
    this.adminTimerModalElement?.classList.remove("timer-modal--show");

    this.document.removeEventListener(`click`, this.onDocumentButtonClick);
  }

  private async getTimers() {
    return await this.api.getUserTimers();
  }

  private renderTimers(timers: TimerType[]) {
    renderElements(this.adminTimerListElement, timers, getTimerItemTemplate);
  }

  private clearTimers() {
    this.timersIntervals.forEach((interval) => clearInterval(interval));
    this.timersIntervals = [];
  }

  private removeTimersItems() {
    Array.from(this.adminTimerListElement.children)
      .forEach((element) => element.remove());
    this.timersIntervals.forEach((interval: number) => clearInterval(interval));
    this.timersIntervals = [];
  }

  startTimer(element: HTMLElement) {
    const hoursElement = element.querySelector(`.js-timer-hours`)!;
    const minutesElement = element.querySelector(`.js-timer-minutes`)!;
    const secondsElement = element.querySelector(`.js-timer-seconds`)!;

    let hours = +hoursElement.textContent!;
    let minutes = +minutesElement.textContent!;
    let seconds = +secondsElement.textContent!;

    const intervalId = setInterval(() => {
      seconds++;

      if (seconds === 60) {
        seconds = 0;
        minutes++;
      }

      if (minutes === 60) {
        minutes = 0;
        hours++;
      }

      hoursElement.textContent = `${hours < 10 ? `0${hours}` : hours}`;
      minutesElement.textContent = `${minutes < 10 ? `0${minutes}` : minutes}`;
      secondsElement.textContent = `${seconds < 10 ? `0${seconds}` : seconds}`;
    }, 1000);

    this.timersIntervals.push((intervalId as unknown as number));
  }

  private startTimers() {
    Array.from(this.adminTimerListElement.children)
      .forEach(this.startTimer);
  }

  onDocumentButtonClick(evt: Event) {
    const target = evt.target as HTMLElement;
    const itsAdminTimerList = target === this.adminTimerModalElement || this.adminTimerModalElement!.contains(target);
    const itsAdminTimerButton = target === this.adminTimerButtonElement;

    if (!itsAdminTimerList && !itsAdminTimerButton) {
      this.closeTimerList();
      this.removeTimersItems();
      this.clearTimers();
      this.toggleOpenStatus();
    }
  }

  async onTimerButtonClick(evt) {
    evt.stopPropagation();

    if (this.isOpenList) {
      this.closeTimerList();
      this.removeTimersItems();
      this.clearTimers();
    } else {
      const timers: TimerType[] = await this.getTimers();
      if (timers.length) {
        this.renderTimers(timers);
        this.startTimers();
      }

      this.openTimerList();
    }

    this.toggleOpenStatus();
  }
}
